import { defineRecipe } from '@chakra-ui/react';

/** A page-navigation link: a card on compact lists, a plain row in a sidebar. */
export const navigationItemRecipe = defineRecipe({
  className: 'tp-navigation-item',
  base: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    minHeight: '48px',
    width: '100%',
    gap: 3,
    px: 3,
    py: 2,
    textStyle: 'nav',
    color: 'fg.secondary',
    borderRadius: 'l2',
    borderColor: 'border.subtle',
    transitionProperty: 'background-color, border-color, color',
    transitionDuration: 'fast',
    transitionTimingFunction: 'ease-out',
    _hover: { color: 'fg', bg: 'bg.muted' },
    _currentPage: {
      color: 'fg',
      bg: 'bg.selected',
      fontWeight: 'semibold',
      _hover: { color: 'fg', bg: 'bg.selected' },
    },
    _focusVisible: {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'purple.focusRing',
      outlineOffset: '2px',
    },
    _motionReduce: { transition: 'none' },
  },
  variants: {
    surface: {
      card: { bg: 'bg.card', borderWidth: '1px' },
      plain: { bg: 'transparent', borderWidth: '0' },
    },
  },
  defaultVariants: { surface: 'plain' },
});
